import React, { useCallback } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useDropzone } from 'react-dropzone';

export default props => {
  const onDrop = useCallback(acceptedFiles => {
    props.onImageUpload(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
  let confirmBtn = null;
  if (props.uploadedFiles.length > 0) {
    confirmBtn = (
      <button className="btn btn-success" onClick={() => props.onConfirm()}>
        Submit
      </button>
    );
  }

  let pageOptions = [];
  for (let i = 0; i < props.totalPages + 1; i++) {
    pageOptions.push(<option key={i}>{i + 1}</option>);
  }
  console.log('error', props.error);
  return (
    <Modal isOpen={props.modal} toggle={props.onCancel} fade={false}>
      <ModalHeader>Insert Page</ModalHeader>
      <ModalBody>
        <div
          {...getRootProps()}
          style={{
            textAlign: 'center',
            verticalAlign: 'middle',
            lineHeight: '494px',
            maxHeight: '500px',
            overflowY: 'scroll',
            borderStyle: 'dotted'
          }}
        >
          <input
            {...getInputProps()}
            accept="image/png, image/jpg, image/tif"
          />
          {isDragActive ? (
            <>Drop the file here ...</>
          ) : props.uploadedFiles.length > 0 ? (
            props.uploadedFiles.map((file, index) => {
              return (
                <div
                  key={`imagethumb_${index}`}
                  style={{
                    margin: '20px 20px 20px 20px',
                    borderStyle: 'solid'
                  }}
                >
                  <img
                    style={{ maxWidth: '100%' }}
                    src={URL.createObjectURL(file)}
                  />
                </div>
              );
            })
          ) : (
            <>Drop your file here, or click to select a file</>
          )}
        </div>
        {props.error && (
          <>
            <br />
            <div className="alert alert-danger">{props.error}</div>
          </>
        )}
        <br />
        <div className="row row-fluid">
          <div className="col col-9">
            <label>
              Plese select the position you wish to insert the page(s) into the
              document:
            </label>
          </div>
          <div className="col col-3">
            <select
              name="lowGradeLevel"
              value={props.startPage}
              onChange={props.onPageChange}
              className="form-control"
            >
              {pageOptions}
            </select>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {confirmBtn}
        <button className="btn btn-danger" onClick={() => props.onCancel()}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};
